export const DEMO_TRANSACTION_DATA = [
  {
    user_id: 'demo_a6433354',
    player_id: 'demo_b2b242a6',
    modified_at: 1727387201,
    player_name: 'demo_467824cf',
    item_id: 'itm_eDTjNdoPyGC',
    item_name: 'Scroll of Shadows',
    payment_method_id: 'pm_exUhsGwWtYXHaXoteHywRuVKBXwOo',
    payment_method_name: 'checkout',
    status: 'done',
    currency: 'CAD',
    country: 'CA',
    payment_id: 'pmt_eBUKctlYmDHTlKuBJVJuApNQJytr',
    ps_tx_id: 'pay_nqksnizflzrenimqutxybspzba',
    payment_number: '24082771575595421',
    checkout_profile_id: 'a',
    order_id: 'demo_ord_eBUKbldmybo',
    card_last_4_digits: '6426',
    card_bin: '533621',
    card_scheme: 'mastercard',
    total: 3880,
    total_order_currency_billing: 776,
    total_usd: 2886.04582,
    total_usd_revenue: 2187.042545,
    user_local_price: 699,
    currency_minor_unit: 2,
    fees: [
      {
        amount: '22.504',
        amount_order_currency: '22.504',
        amount_usd: '16.739066',
        amount_display: '$0.22',
        prc: '2.9',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '40.332',
        amount_order_currency: '40.332',
        amount_usd: '30',
        amount_display: '$0.40',
        prc: '0',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '38.8',
        amount_order_currency: '38.8',
        amount_usd: '28.860458',
        amount_display: '$0.38',
        prc: '5',
        name: 'service',
        included: true,
        visible: false,
      },
      {
        amount: '9.312',
        amount_order_currency: '9.312',
        amount_usd: '6.92651',
        amount_display: '$0.09',
        prc: '1.2',
        name: 'fx',
        included: true,
        visible: false,
      },
    ],
    taxes: [
      {
        amount: 77,
        amount_order_currency: '77',
        amount_usd: '57.274621',
        display_amount: '$0.77',
        prc: '11.01574',
        name: 'gst',
        included: false,
        visible: false,
      },
    ],
    refund_customer_id: '',
    refund_reason: '',
    ip: '2605:b100:71d:9d7:0:11:ecae:c01',
    created_at: 1727387195,
    fail_reason: '',
    fail_reason_code: '',
    status_updated_at: 1727387201,
    order_field: 300,
  },
  {
    user_id: 'demo_dbb094ec',
    player_id: 'demo_126f30b2',
    modified_at: 1727377314,
    player_name: 'demo_0f20de63',
    item_id: 'itm_eDTjNdtijFe',
    item_name: 'Scroll of Shadows',
    payment_method_id: 'pm_eyQhXKPKQpWAnpkaMZMjzrRmkBaVr',
    payment_method_name: 'google_checkout',
    status: 'done',
    currency: 'USD',
    country: 'US',
    payment_id: 'pmt_eBUGumDfJeCfTtORwARqnMKtfgCO',
    ps_tx_id: 'pay_kbyjqplutbxu7gett6zoygfzwq',
    payment_number: '24082798422381691',
    checkout_profile_id: 'a',
    order_id: 'demo_ord_eBUGtSmiSEU',
    card_last_4_digits: '',
    card_bin: '',
    card_scheme: '',
    total: 48960,
    total_order_currency_billing: 1088,
    total_usd: 48960,
    total_usd_revenue: 39737.16,
    user_local_price: 999,
    currency_minor_unit: 2,
    fees: [
      {
        amount: '31.552',
        amount_order_currency: '31.552',
        amount_usd: '31.552',
        amount_display: '$0.31',
        prc: '2.9',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '30',
        amount_order_currency: '30',
        amount_usd: '30',
        amount_display: '$0.30',
        prc: '0',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '54.4',
        amount_order_currency: '54.4',
        amount_usd: '54.4',
        amount_display: '$0.54',
        prc: '5',
        name: 'service',
        included: true,
        visible: false,
      },
      {
        amount: '0',
        amount_order_currency: '0',
        amount_usd: '0',
        amount_display: '$0.00',
        prc: '0',
        name: 'fx',
        included: true,
        visible: false,
      },
    ],
    taxes: [
      {
        amount: 89,
        amount_order_currency: '89',
        amount_usd: '89',
        display_amount: '$0.89',
        prc: '8.90891',
        name: 'sales_tax',
        included: false,
        visible: false,
      },
    ],
    refund_customer_id: '',
    refund_reason: '',
    ip: '162.83.224.3',
    created_at: 1727377308,
    fail_reason: '',
    fail_reason_code: '',
    status_updated_at: 1727377314,
    order_field: 300,
  },
  {
    user_id: 'demo_8566620e',
    player_id: 'demo_adaccc7c',
    modified_at: 1727354590,
    player_name: 'demo_43165931',
    item_id: 'itm_eDTjNdoPyGC',
    item_name: 'Scroll of Shadows',
    payment_method_id: 'pm_eyQhXKPKQpWAnpkaMZMjzrRmkBaVr',
    payment_method_name: 'google_checkout',
    status: 'done',
    currency: 'USD',
    country: 'US',
    payment_id: 'pmt_eBUxZmwJJAsvGfhpZvbOEZyefvnd',
    ps_tx_id: 'pay_ddotdz6jheoe5kahfo46jtpzvi',
    payment_number: '24082790115687011',
    checkout_profile_id: 'a',
    order_id: 'demo_ord_eBUxYXwQgWF',
    card_last_4_digits: '',
    card_bin: '',
    card_scheme: '',
    total: 248130,
    total_order_currency_billing: 5514,
    total_usd: 248130,
    total_usd_revenue: 204002.73,
    user_local_price: 4999,
    currency_minor_unit: 2,
    fees: [
      {
        amount: '159.906',
        amount_order_currency: '159.906',
        amount_usd: '159.906',
        amount_display: '$1.59',
        prc: '2.9',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '30',
        amount_order_currency: '30',
        amount_usd: '30',
        amount_display: '$0.30',
        prc: '0',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '275.7',
        amount_order_currency: '275.7',
        amount_usd: '275.7',
        amount_display: '$2.75',
        prc: '5',
        name: 'service',
        included: true,
        visible: false,
      },
      {
        amount: '0',
        amount_order_currency: '0',
        amount_usd: '0',
        amount_display: '$0.00',
        prc: '0',
        name: 'fx',
        included: true,
        visible: false,
      },
    ],
    taxes: [
      {
        amount: 515,
        amount_order_currency: '515',
        amount_usd: '515',
        display_amount: '$5.15',
        prc: '10.30206',
        name: 'sales_tax',
        included: false,
        visible: false,
      },
    ],
    refund_customer_id: '',
    refund_reason: '',
    ip: '134.204.3.150',
    created_at: 1727354584,
    fail_reason: '',
    fail_reason_code: '',
    status_updated_at: 1727354590,
    order_field: 300,
  },
  {
    user_id: 'demo_bee97b21',
    player_id: 'demo_4ca2c986',
    modified_at: 1727323571,
    player_name: 'demo_2c426116',
    item_id: 'itm_eDTjNdoPyGC',
    item_name: 'Scroll of Shadows',
    payment_method_id: 'pm_exUhsGwWtYXHaXoteHywRuVKBXwOo',
    payment_method_name: 'checkout',
    status: 'done',
    currency: 'PEN',
    country: 'PE',
    payment_id: 'pmt_eBUmALWkzwItzvBTnWgIsVwqDZmZ',
    ps_tx_id: 'pay_q5mpwxeiof7uzevuk6mq5bljze',
    payment_number: '24082756779632521',
    checkout_profile_id: 'a',
    order_id: 'demo_ord_eBUmwKiXZiq',
    card_last_4_digits: '2894',
    card_bin: '455788',
    card_scheme: 'visa',
    total: 19950,
    total_order_currency_billing: 3990,
    total_usd: 5313.62365,
    total_usd_revenue: 4611.00679,
    user_local_price: 3990,
    currency_minor_unit: 2,
    fees: [
      {
        amount: '115.71',
        amount_order_currency: '115.71',
        amount_usd: '30.819017',
        amount_display: 'S/.1.15',
        prc: '2.9',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '112.635',
        amount_order_currency: '112.635',
        amount_usd: '30',
        amount_display: 'S/.1.12',
        prc: '0',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '199.5',
        amount_order_currency: '199.5',
        amount_usd: '53.136237',
        amount_display: 'S/.1.99',
        prc: '5',
        name: 'service',
        included: true,
        visible: false,
      },
      {
        amount: '99.75',
        amount_order_currency: '99.75',
        amount_usd: '26.568118',
        amount_display: 'S/.0.99',
        prc: '2.5',
        name: 'fx',
        included: true,
        visible: false,
      },
    ],
    taxes: [
      {
        amount: 0,
        amount_order_currency: '0',
        amount_usd: '0',
        display_amount: 'S/.0.00',
        prc: '0',
        name: 'igv',
        included: true,
        visible: false,
      },
    ],
    refund_customer_id: '',
    refund_reason: '',
    ip: '181.67.170.23',
    created_at: 1727323565,
    fail_reason: '',
    fail_reason_code: '',
    status_updated_at: 1727323571,
    order_field: 300,
  },
  {
    user_id: 'demo_abc2eb30',
    player_id: 'demo_70fee9dc',
    modified_at: 1727309188,
    player_name: 'demo_8b6944bc',
    item_id: 'itm_eBRDlvzzsWv',
    item_name: 'Scroll of Shadows',
    payment_method_id: 'pm_exUhsGwWtYXHaXoteHywRuVKBXwOo',
    payment_method_name: 'checkout',
    status: 'done',
    currency: 'USD',
    country: 'US',
    payment_id: 'pmt_eBUhkgDQLjllOrReJkFWMECtjJEw',
    ps_tx_id: 'pay_pwov5hdixz7ejfojbawshj3lbm',
    payment_number: '24082710066777821',
    checkout_profile_id: 'a',
    order_id: 'demo_ord_eBUhiGVozIA',
    card_last_4_digits: '9055',
    card_bin: '449210',
    card_scheme: 'visa',
    total: 8160,
    total_order_currency_billing: 544,
    total_usd: 8160,
    total_usd_revenue: 6390.36,
    user_local_price: 499,
    currency_minor_unit: 2,
    fees: [
      {
        amount: '15.776',
        amount_order_currency: '15.776',
        amount_usd: '15.776',
        amount_display: '$0.15',
        prc: '2.9',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '30',
        amount_order_currency: '30',
        amount_usd: '30',
        amount_display: '$0.30',
        prc: '0',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '27.2',
        amount_order_currency: '27.2',
        amount_usd: '27.2',
        amount_display: '$0.27',
        prc: '5',
        name: 'service',
        included: true,
        visible: false,
      },
      {
        amount: '0',
        amount_order_currency: '0',
        amount_usd: '0',
        amount_display: '$0.00',
        prc: '0',
        name: 'fx',
        included: true,
        visible: false,
      },
    ],
    taxes: [
      {
        amount: 45,
        amount_order_currency: '45',
        amount_usd: '45',
        display_amount: '$0.45',
        prc: '9.01804',
        name: 'sales_tax',
        included: false,
        visible: false,
      },
    ],
    refund_customer_id: '',
    refund_reason: '',
    ip: '2600:1011:b340:c943:bd21:cf12:66c3:38c',
    created_at: 1727309182,
    fail_reason: '',
    fail_reason_code: '',
    status_updated_at: 1727309188,
    order_field: 300,
  },
  {
    user_id: 'demo_d56da7cf',
    player_id: 'demo_2b6e4b56',
    modified_at: 1727308412,
    player_name: 'demo_d2097830',
    item_id: 'itm_eDTjNdoPyGC',
    item_name: 'Scroll of Shadows',
    payment_method_id: 'pm_exUhsGwWtYXHaXoteHywRuVKBXwOo',
    payment_method_name: 'checkout',
    status: 'done',
    currency: 'USD',
    country: 'US',
    payment_id: 'pmt_eBUgVkTRXGXfAQCCZLaRSAugWYAj',
    ps_tx_id: 'pay_fzfc2izrs4ietilcmzd276ak4u',
    payment_number: '24082696919919301',
    checkout_profile_id: 'a',
    order_id: 'demo_ord_eBUgSNXPzqe',
    card_last_4_digits: '9055',
    card_bin: '449210',
    card_scheme: 'visa',
    total: 54525,
    total_order_currency_billing: 2181,
    total_usd: 54525,
    total_usd_revenue: 44917.525,
    user_local_price: 1999,
    currency_minor_unit: 2,
    fees: [
      {
        amount: '63.249',
        amount_order_currency: '63.249',
        amount_usd: '63.249',
        amount_display: '$0.63',
        prc: '2.9',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '30',
        amount_order_currency: '30',
        amount_usd: '30',
        amount_display: '$0.30',
        prc: '0',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '109.05',
        amount_order_currency: '109.05',
        amount_usd: '109.05',
        amount_display: '$1.09',
        prc: '5',
        name: 'service',
        included: true,
        visible: false,
      },
      {
        amount: '0',
        amount_order_currency: '0',
        amount_usd: '0',
        amount_display: '$0.00',
        prc: '0',
        name: 'fx',
        included: true,
        visible: false,
      },
    ],
    taxes: [
      {
        amount: 182,
        amount_order_currency: '182',
        amount_usd: '182',
        display_amount: '$1.82',
        prc: '9.10455',
        name: 'sales_tax',
        included: false,
        visible: false,
      },
    ],
    refund_customer_id: '',
    refund_reason: '',
    ip: '2600:1011:b340:c943:bd21:cf12:66c3:38c',
    created_at: 1727308406,
    fail_reason: '',
    fail_reason_code: '',
    status_updated_at: 1727308412,
    order_field: 300,
  },
  {
    user_id: 'demo_8f8f257e',
    player_id: 'demo_fbd60f4a',
    modified_at: 1727307946,
    player_name: 'demo_e639df24',
    item_id: 'itm_eBRDlvzzsWv',
    item_name: 'Scroll of Shadows',
    payment_method_id: 'pm_exUhsGwWtYXHaXoteHywRuVKBXwOo',
    payment_method_name: 'checkout',
    status: 'done',
    currency: 'MXN',
    country: 'MX',
    payment_id: 'pmt_eBUgMlfdcQWwSqxOhrRPgCYlwnMS',
    ps_tx_id: 'pay_6f3ua7huiplehicktdfbyxxvcu',
    payment_number: '24082666809678041',
    checkout_profile_id: 'plusr_eBqfDdwIiLfa',
    order_id: 'demo_ord_eBUgMaXsudI',
    card_last_4_digits: '9403',
    card_bin: '416916',
    card_scheme: 'visa',
    total: 247500,
    total_order_currency_billing: 9900,
    total_usd: 12761.020875,
    total_usd_revenue: 8923.7339,
    user_local_price: 9900,
    currency_minor_unit: 2,
    fees: [
      {
        amount: '287.1',
        amount_order_currency: '287.1',
        amount_usd: '14.802784',
        amount_display: '$2.87',
        prc: '2.9',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '581.85',
        amount_order_currency: '581.85',
        amount_usd: '30',
        amount_display: '$5.81',
        prc: '0',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '495',
        amount_order_currency: '495',
        amount_usd: '25.522042',
        amount_display: '$4.95',
        prc: '5',
        name: 'service',
        included: true,
        visible: false,
      },
      {
        amount: '247.5',
        amount_order_currency: '247.5',
        amount_usd: '12.761021',
        amount_display: '$2.47',
        prc: '2.5',
        name: 'fx',
        included: true,
        visible: false,
      },
    ],
    taxes: [
      {
        amount: 1366,
        amount_order_currency: '1366',
        amount_usd: '70.405632',
        display_amount: '$13.66',
        prc: '16',
        name: 'iva',
        included: true,
        visible: false,
      },
    ],
    refund_customer_id: '',
    refund_reason: '',
    ip: '2806:105e:f:54de:cd7d:1091:3b89:ec32',
    created_at: 1727307939,
    fail_reason: '',
    fail_reason_code: '',
    status_updated_at: 1727307946,
    order_field: 300,
  },
  {
    user_id: 'demo_fb011e76',
    player_id: 'demo_c3b5ae2d',
    modified_at: 1727284254,
    player_name: 'demo_f5857be2',
    item_id: 'itm_eBRDlvzzsWv',
    item_name: 'Scroll of Shadows',
    payment_method_id: 'pm_exUhsGwWtYXHaXoteHywRuVKBXwOo',
    payment_method_name: 'checkout',
    status: 'done',
    currency: 'USD',
    country: 'US',
    payment_id: 'pmt_eBTXYFvClnylDPCPxgUrqDTCgNhD',
    ps_tx_id: 'pay_uvtvjroj6zgufjp7ax2qedukvq',
    payment_number: '24082673801583581',
    checkout_profile_id: 'a',
    order_id: 'demo_ord_eBTXXvxTHDw',
    card_last_4_digits: '0199',
    card_bin: '440393',
    card_scheme: 'visa',
    total: 2695,
    total_order_currency_billing: 539,
    total_usd: 2695,
    total_usd_revenue: 2132.095,
    user_local_price: 499,
    currency_minor_unit: 2,
    fees: [
      {
        amount: '15.631',
        amount_order_currency: '15.631',
        amount_usd: '15.631',
        amount_display: '$0.15',
        prc: '2.9',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '30',
        amount_order_currency: '30',
        amount_usd: '30',
        amount_display: '$0.30',
        prc: '0',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '26.95',
        amount_order_currency: '26.95',
        amount_usd: '26.95',
        amount_display: '$0.26',
        prc: '5',
        name: 'service',
        included: true,
        visible: false,
      },
      {
        amount: '0',
        amount_order_currency: '0',
        amount_usd: '0',
        amount_display: '$0.00',
        prc: '0',
        name: 'fx',
        included: true,
        visible: false,
      },
    ],
    taxes: [
      {
        amount: 40,
        amount_order_currency: '40',
        amount_usd: '40',
        display_amount: '$0.40',
        prc: '8.01603',
        name: 'sales_tax',
        included: false,
        visible: false,
      },
    ],
    refund_customer_id: '',
    refund_reason: '',
    ip: '206.85.94.110',
    created_at: 1727284248,
    fail_reason: '',
    fail_reason_code: '',
    status_updated_at: 1727284254,
    order_field: 300,
  },
  {
    user_id: 'demo_5515b667',
    player_id: 'demo_03a0bf4b',
    modified_at: 1727282184,
    player_name: 'demo_20794b70',
    item_id: 'itm_eBRDlvDkIHH',
    item_name: 'Mini Monthly Event Relic Pack (August)',
    payment_method_id: 'pm_exUhsGwWtYXHaXoteHywRuVKBXwOo',
    payment_method_name: 'checkout',
    status: 'done',
    currency: 'USD',
    country: 'US',
    payment_id: 'pmt_eBTXkPAgzJkRudMiIqxaMyzbHDMz',
    ps_tx_id: 'pay_7bkn6kp3v5zuhh4j2f6y7yije4',
    payment_number: '24082648864196381',
    checkout_profile_id: 'a',
    order_id: 'demo_ord_eBTXkqBIaty',
    card_last_4_digits: '4415',
    card_bin: '494638',
    card_scheme: 'visa',
    total: 5305,
    total_order_currency_billing: 1061,
    total_usd: 5305,
    total_usd_revenue: 4425.905,
    user_local_price: 999,
    currency_minor_unit: 2,
    fees: [
      {
        amount: '30.769',
        amount_order_currency: '30.769',
        amount_usd: '30.769',
        amount_display: '$0.30',
        prc: '2.9',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '30',
        amount_order_currency: '30',
        amount_usd: '30',
        amount_display: '$0.30',
        prc: '0',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '53.05',
        amount_order_currency: '53.05',
        amount_usd: '53.05',
        amount_display: '$0.53',
        prc: '5',
        name: 'service',
        included: true,
        visible: false,
      },
      {
        amount: '0',
        amount_order_currency: '0',
        amount_usd: '0',
        amount_display: '$0.00',
        prc: '0',
        name: 'fx',
        included: true,
        visible: false,
      },
    ],
    taxes: [
      {
        amount: 62,
        amount_order_currency: '62',
        amount_usd: '62',
        display_amount: '$0.62',
        prc: '6.20621',
        name: 'sales_tax',
        included: false,
        visible: false,
      },
    ],
    refund_customer_id: '',
    refund_reason: '',
    ip: '2601:18e:d001:8690:5d49:8635:f83b:9404',
    created_at: 1727282177,
    fail_reason: '',
    fail_reason_code: '',
    status_updated_at: 1727282184,
    order_field: 300,
  },
  {
    user_id: 'demo_6031e44c',
    player_id: 'demo_efa6127e',
    modified_at: 1727282078,
    player_name: 'demo_7963a8b8',
    item_id: 'itm_eDTjNduSxbT',
    item_name: 'Evil Destroyer',
    payment_method_id: 'pm_exUhsGwWtYXHaXoteHywRuVKBXwOo',
    payment_method_name: 'checkout',
    status: 'done',
    currency: 'USD',
    country: 'US',
    payment_id: 'pmt_eBTXiOSNktYfNSldUESkbTxSWeYL',
    ps_tx_id: 'pay_mjvbzjwl5qruti6twnj5n43rlq',
    payment_number: '24082692193674061',
    checkout_profile_id: 'a',
    order_id: 'demo_ord_eBTXikBlobF',
    card_last_4_digits: '4415',
    card_bin: '494638',
    card_scheme: 'visa',
    total: 37135,
    total_order_currency_billing: 1061,
    total_usd: 37135,
    total_usd_revenue: 30981.335,
    user_local_price: 999,
    currency_minor_unit: 2,
    fees: [
      {
        amount: '30.769',
        amount_order_currency: '30.769',
        amount_usd: '30.769',
        amount_display: '$0.30',
        prc: '2.9',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '30',
        amount_order_currency: '30',
        amount_usd: '30',
        amount_display: '$0.30',
        prc: '0',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '53.05',
        amount_order_currency: '53.05',
        amount_usd: '53.05',
        amount_display: '$0.53',
        prc: '5',
        name: 'service',
        included: true,
        visible: false,
      },
      {
        amount: '0',
        amount_order_currency: '0',
        amount_usd: '0',
        amount_display: '$0.00',
        prc: '0',
        name: 'fx',
        included: true,
        visible: false,
      },
    ],
    taxes: [
      {
        amount: 62,
        amount_order_currency: '62',
        amount_usd: '62',
        display_amount: '$0.62',
        prc: '6.20621',
        name: 'sales_tax',
        included: false,
        visible: false,
      },
    ],
    refund_customer_id: '',
    refund_reason: '',
    ip: '2601:18e:d001:8690:5d49:8635:f83b:9404',
    created_at: 1727282072,
    fail_reason: '',
    fail_reason_code: '',
    status_updated_at: 1727282078,
    order_field: 300,
  },
  {
    user_id: 'demo_0498bf8a',
    player_id: 'demo_56f2890c',
    modified_at: 1727211424,
    player_name: 'demo_4211121b',
    item_id: 'itm_eBRDlvzzsWv',
    item_name: 'Scroll of Shadows',
    payment_method_id: 'pm_exUhsGwWtYXHaXoteHywRuVKBXwOo',
    payment_method_name: 'checkout',
    status: 'done',
    currency: 'PEN',
    country: 'PE',
    payment_id: 'pmt_eBTxccHokZGtWfKcfcKHgbPiOvuE',
    ps_tx_id: 'pay_tyiuesrqa6lelpbzulhdz2yomi',
    payment_number: '24082569451596591',
    checkout_profile_id: 'a',
    order_id: 'demo_ord_eBTwYGfCfit',
    card_last_4_digits: '2894',
    card_bin: '455788',
    card_scheme: 'visa',
    total: 89550,
    total_order_currency_billing: 1990,
    total_usd: 23939.36964,
    total_usd_revenue: 20099.67516,
    user_local_price: 1990,
    currency_minor_unit: 2,
    fees: [
      {
        amount: '57.71',
        amount_order_currency: '57.71',
        amount_usd: '15.427594',
        amount_display: 'S/.0.57',
        prc: '2.9',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '112.221',
        amount_order_currency: '112.221',
        amount_usd: '30',
        amount_display: 'S/.1.12',
        prc: '0',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '99.5',
        amount_order_currency: '99.5',
        amount_usd: '26.5993',
        amount_display: 'S/.0.99',
        prc: '5',
        name: 'service',
        included: true,
        visible: false,
      },
      {
        amount: '49.75',
        amount_order_currency: '49.75',
        amount_usd: '13.29965',
        amount_display: 'S/.0.49',
        prc: '2.5',
        name: 'fx',
        included: true,
        visible: false,
      },
    ],
    taxes: [
      {
        amount: 0,
        amount_order_currency: '0',
        amount_usd: '0',
        display_amount: 'S/.0.00',
        prc: '0',
        name: 'igv',
        included: true,
        visible: false,
      },
    ],
    refund_customer_id: '',
    refund_reason: '',
    ip: '181.67.170.23',
    created_at: 1727211418,
    fail_reason: '',
    fail_reason_code: '',
    status_updated_at: 1727211424,
    order_field: 300,
  },
  {
    user_id: 'demo_b38b6d29',
    player_id: 'demo_22d80c91',
    modified_at: 1727210285,
    player_name: 'demo_f4dd7371',
    item_id: 'itm_eDTjNdoPyGC',
    item_name: 'Scroll of Shadows',
    payment_method_id: 'pm_exUhsGwWtYXHaXoteHywRuVKBXwOo',
    payment_method_name: 'checkout',
    status: 'done',
    currency: 'USD',
    country: 'US',
    payment_id: 'pmt_eBTwGhPlyDkSZXvHZOlBdSnxSxuS',
    ps_tx_id: 'pay_nesks6fxzbue3an4hi5czvfkom',
    payment_number: '24082573503086351',
    checkout_profile_id: 'a',
    order_id: 'demo_ord_eBTwFlPXytB',
    card_last_4_digits: '0605',
    card_bin: '409758',
    card_scheme: 'visa',
    total: 37065,
    total_order_currency_billing: 1059,
    total_usd: 37065,
    total_usd_revenue: 30986.865,
    user_local_price: 999,
    currency_minor_unit: 2,
    fees: [
      {
        amount: '30.711',
        amount_order_currency: '30.711',
        amount_usd: '30.711',
        amount_display: '$0.30',
        prc: '2.9',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '30',
        amount_order_currency: '30',
        amount_usd: '30',
        amount_display: '$0.30',
        prc: '0',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '52.95',
        amount_order_currency: '52.95',
        amount_usd: '52.95',
        amount_display: '$0.52',
        prc: '5',
        name: 'service',
        included: true,
        visible: false,
      },
      {
        amount: '0',
        amount_order_currency: '0',
        amount_usd: '0',
        amount_display: '$0.00',
        prc: '0',
        name: 'fx',
        included: true,
        visible: false,
      },
    ],
    taxes: [
      {
        amount: 60,
        amount_order_currency: '60',
        amount_usd: '60',
        display_amount: '$0.60',
        prc: '6.00601',
        name: 'sales_tax',
        included: false,
        visible: false,
      },
    ],
    refund_customer_id: '',
    refund_reason: '',
    ip: '2600:1700:42d8:c050:7991:14d0:b703:200e',
    created_at: 1727210279,
    fail_reason: '',
    fail_reason_code: '',
    status_updated_at: 1727210285,
    order_field: 300,
  },
  {
    user_id: 'demo_060fb8eb',
    player_id: 'demo_3ea55488',
    modified_at: 1727210065,
    player_name: 'demo_2c0fd89e',
    item_id: 'itm_eDTjNdoPyGC',
    item_name: 'Scroll of Shadows',
    payment_method_id: 'pm_exUhsGwWtYXHaXoteHywRuVKBXwOo',
    payment_method_name: 'checkout',
    status: 'done',
    currency: 'USD',
    country: 'US',
    payment_id: 'pmt_eBTwBVbQXnRJDKiYiDogNANbmMtx',
    ps_tx_id: 'pay_wv5lsibtujdunb37umpoaofshq',
    payment_number: '24082530583086621',
    checkout_profile_id: 'a',
    order_id: 'demo_ord_eBTwAJplURF',
    card_last_4_digits: '0605',
    card_bin: '409758',
    card_scheme: 'visa',
    total: 10595,
    total_order_currency_billing: 2119,
    total_usd: 10595,
    total_usd_revenue: 9007.995,
    user_local_price: 1999,
    currency_minor_unit: 2,
    fees: [
      {
        amount: '61.451',
        amount_order_currency: '61.451',
        amount_usd: '61.451',
        amount_display: '$0.61',
        prc: '2.9',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '30',
        amount_order_currency: '30',
        amount_usd: '30',
        amount_display: '$0.30',
        prc: '0',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '105.95',
        amount_order_currency: '105.95',
        amount_usd: '105.95',
        amount_display: '$1.05',
        prc: '5',
        name: 'service',
        included: true,
        visible: false,
      },
      {
        amount: '0',
        amount_order_currency: '0',
        amount_usd: '0',
        amount_display: '$0.00',
        prc: '0',
        name: 'fx',
        included: true,
        visible: false,
      },
    ],
    taxes: [
      {
        amount: 120,
        amount_order_currency: '120',
        amount_usd: '120',
        display_amount: '$1.20',
        prc: '6.003',
        name: 'sales_tax',
        included: false,
        visible: false,
      },
    ],
    refund_customer_id: '',
    refund_reason: '',
    ip: '2600:1700:42d8:c050:7991:14d0:b703:200e',
    created_at: 1727210059,
    fail_reason: '',
    fail_reason_code: '',
    status_updated_at: 1727210065,
    order_field: 300,
  },
  {
    user_id: 'demo_8f15a043',
    player_id: 'demo_b15c2fb1',
    modified_at: 1727202006,
    player_name: 'demo_30534e7e',
    item_id: 'itm_eDTjNduSxbT',
    item_name: '575 Theonite & itm_eDTjNduSxbT',
    payment_method_id: 'pm_exUhsGwWtYXHaXoteHywRuVKBXwOo',
    payment_method_name: 'checkout',
    status: 'done',
    currency: 'USD',
    country: 'PR',
    payment_id: 'pmt_eBTtCWFpEXwhiEGAIFiHQBPHtNoF',
    ps_tx_id: 'pay_mdkayh4qazyepeis3evw3qgxky',
    payment_number: '24082567278826251',
    checkout_profile_id: 'a',
    order_id: 'demo_ord_eBTtAMsGKhS',
    card_last_4_digits: '6049',
    card_bin: '454951',
    card_scheme: 'visa',
    total: 14985,
    total_order_currency_billing: 999,
    total_usd: 14985,
    total_usd_revenue: 13351.185,
    user_local_price: 999,
    currency_minor_unit: 2,
    fees: [
      {
        amount: '28.971',
        amount_order_currency: '28.971',
        amount_usd: '28.971',
        amount_display: '$0.28',
        prc: '2.9',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '30',
        amount_order_currency: '30',
        amount_usd: '30',
        amount_display: '$0.30',
        prc: '0',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '49.95',
        amount_order_currency: '49.95',
        amount_usd: '49.95',
        amount_display: '$0.49',
        prc: '5',
        name: 'service',
        included: true,
        visible: false,
      },
      {
        amount: '0',
        amount_order_currency: '0',
        amount_usd: '0',
        amount_display: '$0.00',
        prc: '0',
        name: 'fx',
        included: true,
        visible: false,
      },
    ],
    taxes: [
      {
        amount: 0,
        amount_order_currency: '0',
        amount_usd: '0',
        display_amount: '$0.00',
        prc: '0',
        name: 'ivu',
        included: true,
        visible: false,
      },
    ],
    refund_customer_id: '',
    refund_reason: '',
    ip: '24.171.221.148',
    created_at: 1727202000,
    fail_reason: '',
    fail_reason_code: '',
    status_updated_at: 1727202006,
    order_field: 300,
  },
  {
    user_id: 'demo_4e84e19b',
    player_id: 'demo_dc12327f',
    modified_at: 1727190600,
    player_name: 'demo_33cc9e24',
    item_id: 'itm_eBRDlvtSQaW',
    item_name: '1210 Theonite & Premiere Relics Bundle',
    payment_method_id: 'pm_eyQhXKPKQpWAnpkaMZMjzrRmkBaVr',
    payment_method_name: 'google_checkout',
    status: 'done',
    currency: 'USD',
    country: 'US',
    payment_id: 'pmt_eBTprEDDjbeWTYbsCcVcaDIeBbwm',
    ps_tx_id: 'pay_wq54lyt5kw6u5antylfz37j6oe',
    payment_number: '24082572294418911',
    checkout_profile_id: 'a',
    order_id: 'demo_ord_eBTprnoYZpJ',
    card_last_4_digits: '',
    card_bin: '',
    card_scheme: '',
    total: 32535,
    total_order_currency_billing: 2169,
    total_usd: 32535,
    total_usd_revenue: 26964.735,
    user_local_price: 1999,
    currency_minor_unit: 2,
    fees: [
      {
        amount: '62.901',
        amount_order_currency: '62.901',
        amount_usd: '62.901',
        amount_display: '$0.62',
        prc: '2.9',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '30',
        amount_order_currency: '30',
        amount_usd: '30',
        amount_display: '$0.30',
        prc: '0',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '108.45',
        amount_order_currency: '108.45',
        amount_usd: '108.45',
        amount_display: '$1.08',
        prc: '5',
        name: 'service',
        included: true,
        visible: false,
      },
      {
        amount: '0',
        amount_order_currency: '0',
        amount_usd: '0',
        amount_display: '$0.00',
        prc: '0',
        name: 'fx',
        included: true,
        visible: false,
      },
    ],
    taxes: [
      {
        amount: 170,
        amount_order_currency: '170',
        amount_usd: '170',
        display_amount: '$1.70',
        prc: '8.50425',
        name: 'sales_tax',
        included: false,
        visible: false,
      },
    ],
    refund_customer_id: '',
    refund_reason: '',
    ip: '2600:1702:4560:2b70:2495:a6f:676d:94a6',
    created_at: 1727190594,
    fail_reason: '',
    fail_reason_code: '',
    status_updated_at: 1727190600,
    order_field: 300,
  },
  {
    user_id: 'demo_3a343fb8',
    player_id: 'demo_ce7a4b47',
    modified_at: 1727164732,
    player_name: 'demo_6e3fe7da',
    item_id: 'itm_eDTjNdoPyGC',
    item_name: 'Scroll of Shadows',
    payment_method_id: 'pm_exUhsGwWtYXHaXoteHywRuVKBXwOo',
    payment_method_name: 'checkout',
    status: 'done',
    currency: 'SGD',
    country: 'SG',
    payment_id: 'pmt_eBTfOhiOwhyZOUnupaGPFixkkehU',
    ps_tx_id: 'pay_eyjsphcn47wergjrcyeuocnq4m',
    payment_number: '24082577693945611',
    checkout_profile_id: 'plusr_eBTfKPzpHBBa',
    order_id: 'demo_ord_eBTfNurbNiQ',
    card_last_4_digits: '6990',
    card_bin: '462845',
    card_scheme: 'visa',
    total: 22470,
    total_order_currency_billing: 1498,
    total_usd: 17283.2859,
    total_usd_revenue: 15260.506875,
    user_local_price: 1498,
    currency_minor_unit: 2,
    fees: [
      {
        amount: '43.442',
        amount_order_currency: '43.442',
        amount_usd: '33.414353',
        amount_display: '$0.43',
        prc: '2.9',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '39.003',
        amount_order_currency: '39.003',
        amount_usd: '30',
        amount_display: '$0.39',
        prc: '0',
        name: 'payment_method',
        included: true,
        visible: false,
      },
      {
        amount: '74.9',
        amount_order_currency: '74.9',
        amount_usd: '57.610953',
        amount_display: '$0.74',
        prc: '5',
        name: 'service',
        included: true,
        visible: false,
      },
      {
        amount: '17.976',
        amount_order_currency: '17.976',
        amount_usd: '13.826629',
        amount_display: '$0.17',
        prc: '1.2',
        name: 'fx',
        included: true,
        visible: false,
      },
    ],
    taxes: [
      {
        amount: 0,
        amount_order_currency: '0',
        amount_usd: '0',
        display_amount: '$0.00',
        prc: '0',
        name: 'gst',
        included: true,
        visible: false,
      },
    ],
    refund_customer_id: '',
    refund_reason: '',
    ip: '2404:e801:2003:1413:718c:7fd6:673e:7525',
    created_at: 1727164727,
    fail_reason: '',
    fail_reason_code: '',
    status_updated_at: 1727164732,
    order_field: 300,
  },
]
